import { EditOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useMemo, useState } from 'react';
import { FormEntry } from '@/presentation/components/form';
import { FilterArray } from '@/presentation/components/form/setting/filter-array';
import styles from '@/presentation/components/tds-form/tds-fields-filter/index.module.scss';

export interface FilterPanelProps {
  entries: FormEntry[];
  defaultSelectedEntries: FormEntry[];
  onSelectedChange?: (selectedEntries: FormEntry[]) => void;
  style?: React.CSSProperties;
}

export const FilterPanel = observer((props: FilterPanelProps) => {
  const { entries, defaultSelectedEntries, onSelectedChange, style } = props;
  const [visible, setVisible] = useState(false);

  const popMenu = useMemo(() => (
    <FilterArray
      entries={entries}
      defaultSelectedEntries={defaultSelectedEntries}
      onSelectedChange={(entries) => {
        onSelectedChange?.(entries);
      }}
    />
  ), [entries, defaultSelectedEntries]);

  return (
    <Popover
      visible={visible}
      onVisibleChange={visible => setVisible(visible)}
      content={popMenu}
      trigger='click'
      placement='bottom'
      destroyTooltipOnHide
      overlayClassName={styles.overlay}
    >
      <Button icon={<EditOutlined />} style={style}>编辑字段</Button>
    </Popover>
  );
});
